import React from "react";
import MapWithTransferTimesContainer from "components/shared/MapWithTransferTimesContainer";

const TransferAnalyzerMap = ({ usersInTheTransfer, school, type, transfertime }) => {
  if (!usersInTheTransfer.length) {
    return null;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", columnGap: "10px" }}>
      <MapWithTransferTimesContainer
        stops={usersInTheTransfer}
        origin={school}
        type={type}
        enablePolyline={false}
        transferStartFinishTime={transfertime}
        isFullScreen={true}
      />
    </div>
  );
};

export default TransferAnalyzerMap;
